import { getDifferenceInHours } from "@/utils/time"
import { WABAChannelChatFreeEntryPointWindowStatus } from "@/@integrations/WABA/protocols/wabaChannelChatFreeEntryPointWindow"

const FREE_ENTRY_POINT_WINDOW_EXPIRING_THRESHOLD_IN_HOURS = 6
const MINUTES_IN_ONE_HOUR = 60

type useMetaFreeEntryPointWindowProps = {
	status: WABAChannelChatFreeEntryPointWindowStatus
	scheduledPauseAt?: Date
}

export const useMetaFreeEntryPointWindow = (props: useMetaFreeEntryPointWindowProps) => {
	const {
		status,
		scheduledPauseAt
	} = props

	const formattedSchedulePausedDate = new Date(scheduledPauseAt as Date)
	const canShowPauseDate = status === "active" && scheduledPauseAt
	const remainingHours = canShowPauseDate ? getDifferenceInHours(formattedSchedulePausedDate, new Date()) : 0
	const canShowExpiringWarning = canShowPauseDate && remainingHours < FREE_ENTRY_POINT_WINDOW_EXPIRING_THRESHOLD_IN_HOURS

	const getFormattedRemainingTime = () => {
		if (!canShowPauseDate) {
			return ""
		}

		const remainingMilliseconds = formattedSchedulePausedDate.getTime() - new Date().getTime()
		const totalRemainingMinutes = Math.max(0, Math.floor(remainingMilliseconds / (1000 * MINUTES_IN_ONE_HOUR)))
		const remainingHoursFromMinutes = Math.floor(totalRemainingMinutes / MINUTES_IN_ONE_HOUR)
		const remainingMinutes = totalRemainingMinutes % MINUTES_IN_ONE_HOUR

		return `${remainingHoursFromMinutes}h ${String(remainingMinutes).padStart(2, "0")}min restantes`
	}

	const getStatusMessage = () => {
		const metaFreeEntryPointWindowStatusToStatusMessage: Record<WABAChannelChatFreeEntryPointWindowStatus, string> = {
			active: "Modo Meta: custo reduzido ativo",
			paused: "Modo Meta: custo reduzido encerrado"
		}

		return metaFreeEntryPointWindowStatusToStatusMessage[status]
	}

	return {
		canShowExpiringWarning,
		formattedSchedulePausedDate,
		canShowPauseDate,
		formattedRemainingTime: getFormattedRemainingTime(),
		statusMessage: getStatusMessage()
	}
}
